import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button} from "react-bootstrap";
import APICom from "../../../../utils/helpers/APICom";


const AtLocation = (props) => {
    
    const { loginData } = useSelector((store) => store.login);
    const { ASCSSettingData, BrokerServingAffiliatesData }  = useSelector((store) => store.combinedata);
    const [ showATLOCATIONAlert, setATLOCATIONAlert] = useState(false);
    const [ atlocationAlertObj, setATLOCATIONAlertObj] = useState({alertTitle: '', alertMsg:''});
    const [ dispatchMethod, setDispatchMethod] = useState(0);

    useEffect(() => {
        
        if(!props.GridRowData || props.GridRowData.length <= 0)
        {
            setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'No trip selected', alertMsg:'No request selected to perform ATLOCATION.'});
            setATLOCATIONAlert(true);
        }
        else
        {
            const gData = props.GridRowData[0];
            let filteredAffiliates = [];
            try{
                if(BrokerServingAffiliatesData !== "")
                {
                    filteredAffiliates = BrokerServingAffiliatesData?.filter(
                        (aff) => String(aff.iBrokerAffiliateID) === String(gData.iSRATSPID)
                    );
                }
            }
            catch(e){
              
            }
            if(filteredAffiliates?.length > 0)
            {
                setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Action Restriction', alertMsg: `The trip is assigned to an Affiliate (${gData.Affiliate}) and only Affiliate can initiate this action.`});
                setATLOCATIONAlert(true);
            }
            else if(gData.iServiceStatusID !== "3")
            {
                setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Invalid Action', alertMsg: "Action not allowed on un-dispatched trip."});
                setATLOCATIONAlert(true);
            }
            else if(gData.TripRequestStatus.toLowerCase() === "cancelled")
            {
                setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Invalid Action', alertMsg: "Cannot perform At Location action on 'CANCELLED' trip."});
                setATLOCATIONAlert(true);
            }
            else if(gData.TripRequestStatus.toLowerCase() === "accepted")
            {
                setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Invalid Action', alertMsg: "Cannot perform At Location action on 'ACCEPTED' trip."});
                setATLOCATIONAlert(true);
            }
            else if(gData.TripRequestStatus.toLowerCase() === "pickedup" || gData.TripRequestStatus.toLowerCase() === "dropped")
            {
                setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Invalid Action', alertMsg: "Request '" + gData.ConfirmationNo + "' is already '" + gData.TripRequestStatus + "' and cannot be updated as 'Vehicle At Location'."});
                setATLOCATIONAlert(true);
            }
            else if(parseInt((gData.iAssignedVehicleId === "")? "-1" : gData.iAssignedVehicleId) <= 0)
            {
                setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Invalid Action', alertMsg: "Please first assign cab to the request."});
                setATLOCATIONAlert(true);
            }
            else
            {
                if(ASCSSettingData !== null && ASCSSettingData !== undefined)
                {
                    if (ASCSSettingData.hasOwnProperty(props.GridRowData[0].iSRATSPID)) {
                      const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[props.GridRowData[0].iSRATSPID]); // Parse JSON string into an array
                      for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
                      {
                          if(ascsSettingDataByAffiliate[i]["SubTitle"] === "DispatchMethod")
                          {
                              setDispatchMethod(ascsSettingDataByAffiliate[i]["value"]);
                          }
                      }
                    }
                }
                
                PerformManualVehicleAtLocation();
            }
        }

    }, [props.GridRowData, BrokerServingAffiliatesData, ASCSSettingData]);

    const PerformManualVehicleAtLocation = async () => {
        const gData = props.GridRowData[0];
        var Param = {
          "iServiceID": gData.ServiceID,
          "DispatchedBy": dispatchMethod,
          "iRefID": gData.ConfirmationNo,
          "iUserID": loginData.iUserID
        }
        let response = await APICom.fetchData("", "TripActions/PerformManualVehicleAtLocation", "post", { "Content-Type": "application/json" }, Param, null);
        let result = response.data;
        if(result.count > 0)
        {
            setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Vehicle AT Location Action', alertMsg: "Action performed successfully."});
            setATLOCATIONAlert(true);
            props.GridRowData[0].TripRequestStatus = 'ATLOCATION'
        }
        else
        {
            setATLOCATIONAlertObj({...atlocationAlertObj, alertTitle: 'Vehicle AT Location Failed', alertMsg: "Action failed."});
            setATLOCATIONAlert(true);
        }
        //props.ReloadDataFunction();
      }

    const handleATLOCATIONAlertClose = () => {
        setATLOCATIONAlert(false);
        UnMountATLOCATIONComponent();
      }
    
      const UnMountATLOCATIONComponent = () => {
        if(props.atlocationComponentLoaded)
        {
          props.setAtLocationProcessing(false);
          props.setATLOCATIONComponentLoad(false);
        }
      }

      return(
        <>
             { showATLOCATIONAlert && <Modal centered show={showATLOCATIONAlert} onHide={handleATLOCATIONAlertClose} animation={false} >
                                  <Modal.Header className='activate_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                                    <Modal.Title className='activate_dialog_title_color'>{atlocationAlertObj.alertTitle}</Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body><b>{atlocationAlertObj.alertMsg}</b></Modal.Body>
                                  <Modal.Footer>
                                    <Button variant="secondary" onClick={handleATLOCATIONAlertClose}>
                                      Close
                                    </Button>
                                  </Modal.Footer>
                                </Modal>}
        </>
      );
};

export default AtLocation;
